import './App.css';
// CSS for visualization
import '@joint/plus/joint-plus.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/toast-overrides.css';
import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import router from './routes';
import { RouteTableContext } from './access';
import { useQueryClient } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
  const queryClient = useQueryClient();
  const [appRouter] = useState(() => router(queryClient));
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <RouteTableContext.Provider value={appRouter.routes}>
          <RouterProvider router={appRouter} />
        </RouteTableContext.Provider>
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss={false}
          pauseOnHover
          draggable={true}
          theme="light"
        />
      </LocalizationProvider>
    </>
  );
}

export default App;
